import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ArchivoInfo } from 'app/shared/interfaces/cv-form';
import { MatIconRegistry, MatIcon } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-file-upload-button',
  standalone: true,
  templateUrl: './file-upload-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon],
})
export class FileUploadButtonComponent {
  constructor(
    private readonly iconRegistry: MatIconRegistry,
    private readonly sanitizer: DomSanitizer,
  ) {
    this.iconRegistry.addSvgIcon(
      'download-icon',
      this.sanitizer.bypassSecurityTrustResourceUrl('icons/download_icon.svg'),
    );
  }

  file = input<ArchivoInfo | null>(null);

  upload = output<void>();
  download = output<ArchivoInfo>();
  delete = output<ArchivoInfo>();

  onUpload(): void {
    this.upload.emit();
  }

  onDownload(): void {
    const file = this.file();
    if (file) this.download.emit(file);
  }

  onDelete(): void {
    const file = this.file();
    if (file) this.delete.emit(file);
  }
}
